var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn--front-blue btn-super-wide",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.postFillSection($event)}}},[_c('span',{staticClass:"glyphicon glyphicon-download",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.label))])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6913f90c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/vue/postfill-section.vue
// module id = dYgt
// module chunks = 0